// @flow

import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.freeDammCero',
  title: 'hardCoded.title.freeDammCero',
  slug: titleToSlug('hardCoded.title.freeDammCero'),
  catalog: {
    title: 'hardCoded.catalog.title.freeDammCero',
    catalogMedia,
    price: numberToCurrency('2.75'),
    color: '#009ade'
  }
}
